import styled from 'styled-components';

const ValidationErrorMessage = styled.div`
  color: ${p => p.theme.danger};
  font-size: 12px;
  padding-top: 2px;
`;

export default ValidationErrorMessage;
